<template>
  <v-main>
    <stepper-tin
      v-if="
        items && items.quizzs.length && items.quizzs[0].department === 'TIN'
      "
      :questions="items.quizzs[0].questions"
      :filieres="items.quizzs[0].filieres"
    />
    <stepper-tic
      v-if="
        items && items.quizzs.length && items.quizzs[0].department === 'TIC'
      "
      :questions="items.quizzs[0].questions"
      :filieres="items.quizzs[0].filieres"
    />
  </v-main>
</template>

<script>
import StepperTin from "@/components/StepperTin.vue";
import StepperTic from "@/components/StepperTic.vue";
import gql from "graphql-tag";

export default {
  name: "Quizzs",
  components: {
    StepperTin,
    StepperTic,
  },
  apollo: {
    items: {
      query: gql`
        query($quizzId: ID!) {
          items {
            quizzs(filter: { id: { _eq: $quizzId } }) {
              department
              id
              filieres(sort: "name") {
                id
                name
                description
                link
              }
              questions(sort: "date_created") {
                id
                content
                weight
                answers {
                  id
                  content
                  filiere {
                    id
                    name
                  }
                  filieres {
                    filieres_id {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          quizzId: this.$route.params.id,
        };
      },
    },
  },
};
</script>